import styled from "styled-components";

export const Content = styled.div`
  margin-top: 60px;
`

export const Wrapper = styled.div`
  position: relative;
`

export const Calculate = styled.div`
  background: rgba(170, 177, 255, 0.5);
  border-radius: 10px;
  width: 100%;
  max-width: 480px;
  height: 200px;
  margin: 0 auto;
  padding: 21px 0;
`

export const CalculateBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const IncDecBtn = styled.button`
  margin: 0 8px
`

export const UsersCountInput = styled.input`
  text-align: center;
  font-size: 18px;
  color: #2A2637;
  border: 1px solid transparent;
  border-radius: 4px;
  width: 100%;
  max-width: 220px;
  height: 38px;
  transition: border 0.2s;
  
  &::-webkit-input-placeholder {
    font-size: 18px;
    color: #A8A4B9;
  }
  
  &::-moz-placeholder {
    font-size: 18px;
    color: #A8A4B9;
  }
  
  &:-moz-placeholder {
    font-size: 18px;
    color: #A8A4B9;
  }
  
  &:-ms-input-placeholder {
    font-size: 18px;
    color: #A8A4B9;
  }
  
  &:focus {
    border: 1px solid #797199;
  }
  
  &:hover {
    border: 1px solid #797199;
  }
`

export const Result = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  margin: 25px 0 0;
  left: 0;
  right: 0;
`

export const ResultText = styled.div`
  background: rgba(25, 22, 34, 0.9);
  border-radius: 10px;
  color: #FFFFFF;
  font-size: 48px;
  font-weight: 600;
  padding: 42px 60px;
  max-width: 410px;

  @media (min-width: 375px) {
    padding: 42px 65px;
  }
  
  @media (min-width: 980px) {
    font-size: 72px;
  }
`

export const ResultTextPersonal = styled(ResultText)`
  font-weight: 500;
  font-size: 18px;
  padding: 45px 36px;
  line-height: 1.5em;
  text-align: center;
`

export const ResultLink = styled.a`
  color: #aab1ff
`

export const Default = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: center;
  margin: 55px 0 0;

  @media (min-width: 980px) {
    margin: 120px 0 0;
    align-items: flex-start;
  }
`

export const DefaultBlock = styled.div`
  flex: 0 0 100%;
  padding: 15px 0;

  @media (min-width: 414px) {
    flex: 0 0 50%;
    max-width: 50%;
  }
  
  @media (min-width: 980px) {
    margin: 24px 41px;
    padding: 0;
    flex: 0 0 auto;
  }
`

export const DefaultHeader = styled.div`
  color: #797199;
  font-size: 14px;
  margin: 0 0 12px;
`

export const DefaultSubtitle = styled(DefaultHeader)`
  margin-top: 5px;
`

export const DefaultResult = styled.div`
  color: #4E4963;
  font-size: 18px;
  font-weight: 600;
`